/* A student's repository name (D-052, D-053) — shared by the site's panel and
 * by assignments/provision.mjs and collect.mjs, so the link a student clicks
 * and the repository the script made cannot drift apart.
 *
 *   <term>-<template repo>-<username>    fall26-cs140-primitives-game-octocat
 *
 * The term is TERM.name ("Fall 2026") as a slug. Changing TERM for a new term
 * changes every name the site builds — which is the point: last term's
 * repositories stay where they are, under last term's names.
 */
import { TERM } from '../config.js';

export const termSlug = (name = TERM.name) => {
  const m = /^\s*([A-Za-z]+)\s+(\d{4})\s*$/.exec(name);
  if (!m) throw new Error(`TERM.name should look like "Fall 2026", not "${name}"`);
  return m[1].toLowerCase() + m[2].slice(2);
};

export const studentRepo = (templateRepo, github, term = termSlug()) =>
  `${term}-${templateRepo}-${github.toLowerCase()}`;
